module.exports = __webpack_public_path__ + "media/images/logo-6c0e575e0d4aec5c672fba11aef12d0f.svg";